import network from '@/services/network';
import {
  ApiResponse,
  CreateMailTemplateRequest,
  MailPlaceholder,
  MailTemplate,
  PreviewMailTemplatePayload,
  PreviewMailTemplateResponse,
  UpdateMailTemplateRequest,
} from '@/types';
import { ErrorResponse } from '@/utils';

const getMailTemplates = async (): Promise<ApiResponse<MailTemplate[]>> => {
  try {
    const { data } = await network.get<ApiResponse<MailTemplate[]>>('/mail-templates');
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

// Zentraler Platzhalter-Katalog fuer den Variablen-Picker (BE Single Source of Truth).
const getPlaceholders = async (): Promise<MailPlaceholder[]> => {
  try {
    const { data } = await network.get<{ data: MailPlaceholder[] }>(
      '/mail-templates/meta/placeholders',
    );
    return data.data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const getMailTemplate = async (id: number): Promise<ApiResponse<MailTemplate>> => {
  try {
    const { data } = await network.get<ApiResponse<MailTemplate>>(`/mail-templates/${id}`);
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const createMailTemplate = async (
  payload: CreateMailTemplateRequest,
): Promise<ApiResponse<MailTemplate>> => {
  try {
    const { data } = await network.post<ApiResponse<MailTemplate>>(
      '/mail-templates',
      payload,
    );
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const updateMailTemplate = async (
  id: number,
  payload: UpdateMailTemplateRequest,
): Promise<ApiResponse<MailTemplate>> => {
  try {
    const { data } = await network.put<ApiResponse<MailTemplate>>(
      `/mail-templates/${id}`,
      payload,
    );
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const deleteMailTemplate = async (id: number): Promise<void> => {
  try {
    await network.delete(`/mail-templates/${id}`);
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

// Phase 1b: Live-Vorschau (rendert freien Subject/Body mit Beispieldaten
// serverseitig ins Kundenmail-Geruest).
const previewMailTemplate = async (
  payload: PreviewMailTemplatePayload,
): Promise<PreviewMailTemplateResponse> => {
  try {
    const { data } = await network.post<PreviewMailTemplateResponse>(
      '/mail-templates/preview',
      payload,
    );
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

// Phase 1b: „Testmail an mich" — Versand ausschliesslich an den eingeloggten SA.
const sendTestMail = async (id: number): Promise<{ recipient: string }> => {
  try {
    const { data } = await network.post<{ recipient: string }>(
      `/mail-templates/${id}/test-mail`,
    );
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const mailTemplateApi = {
  getMailTemplates,
  getPlaceholders,
  getMailTemplate,
  createMailTemplate,
  updateMailTemplate,
  deleteMailTemplate,
  previewMailTemplate,
  sendTestMail,
};

export default mailTemplateApi;
